import { useState, useEffect } from 'react';

// Logo svg
const LogoDark = () => {
    return <>
    <svg width="45" height="45" viewBox="0 0 81 55" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.6445 35.0625L26.2266 0.960938H33.1875L17.9297 44.8711C17.5781 45.8086 17.1094 46.8164 16.5234 47.8945C15.9609 48.9961 15.2344 50.0391 14.3438 51.0234C13.4531 52.0078 12.375 52.8047 11.1094 53.4141C9.86719 54.0469 8.37891 54.3633 6.64453 54.3633C6.12891 54.3633 5.47266 54.293 4.67578 54.1523C3.87891 54.0117 3.31641 53.8945 2.98828 53.8008L2.95312 48.5273C3.14062 48.5508 3.43359 48.5742 3.83203 48.5977C4.25391 48.6445 4.54688 48.668 4.71094 48.668C6.1875 48.668 7.44141 48.4688 8.47266 48.0703C9.50391 47.6953 10.3711 47.0508 11.0742 46.1367C11.8008 45.2461 12.4219 44.0156 12.9375 42.4453L15.6445 35.0625ZM7.875 0.960938L17.7539 30.4922L19.4414 37.3477L14.7656 39.7383L0.773438 0.960938H7.875Z" fill="#03D36B"/>
    <path d="M21 54L36.4576 8L49.5 35.2427L62.5424 8L78 54" stroke="white" strokeWidth="5"/>
    </svg>
    </>
}

// Hamburger svg
const Ham = () => {
    return <>
        <svg width="49" height="36" viewBox="0 0 49 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 3H49" stroke="white" strokeWidth="5"/>
        <path d="M0 19H49" stroke="white" strokeWidth="5"/>
        <path d="M0 33H49" stroke="white" strokeWidth="5"/>
        </svg>

    </>
}

// Menu for moblie
const Menu = ({open, scroll}) => {
    const animate = open ? "animate" : "";

    return <>
        <div className={`menu ${open ? "visible" : ""}`}>
            <ul>
                <li>
                    <a 
                        onClick={() => scroll("home")}
                        className={animate} 
                    >Home</a>
                </li>
                <li>
                    <a 
                        onClick={() => scroll("about")}
                        className={animate} 
                    >About</a>
                </li>
                <li>
                    <a 
                        onClick={() => scroll("projects")}
                        className={animate} 
                    >Projects</a>
                </li>
                <li>
                    <a 
                        onClick={() => scroll("contact")}
                        className={animate} 
                    >Contact</a>
                </li>
            </ul>
        </div>
    </>
}

// navigation
const Nav = () => {
    const [open, setOpen] = useState(false);

    // on resize close the menu if it is open if the screen width is greater than 576 px
    useEffect(() => {
        function resize() {
            if (window.innerWidth > 576) {
                setOpen(false);
            }            
        }

        window.addEventListener("resize", resize);

        return () => {
            window.removeEventListener('resize', resize);
        }
    }, []);

    // scroll to spcific element with ID
    function scroll(id) {
        setOpen(false);
        let elem = document.getElementById(id);
        elem.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest" 
        });
        let scrolled = window.scrollY;
        window.scrollTo(0, scrolled-75);
    }

    return (<>
        <nav>
            <div className='logo'>
                <LogoDark/>
            </div>
            <ul>
                <li><a onClick={() => scroll("home")}>Home</a></li>
                <li><a onClick={() => scroll("about")}>About</a></li>
                <li><a onClick={() => scroll("projects")}>Projects</a></li>
                <li><a onClick={() => scroll("contact")}>Contact</a></li>
            </ul>
            <div className='ham'>
                <button onClick={() => setOpen(!open)} aria-label="menu">
                    {!open ? <Ham/> : "×"}
                </button>
            </div>
        </nav>

        {/* for mobile Menu */}
        <Menu open={open} scroll={scroll} />
    </>);
}

export default Nav;